import {
  VideoOnFill,
  TeamChatFill,
  PhoneFill,
  MailAndCalendarFillProduct,
  SchedulerFill,
  AIDocsFill,
  WhiteboardFill,
  ClipsFill,
  TasksFill,
  FlowFill,
  HubFill,
  VideoManagementFill,
  RoomsFill,
  WorkspaceReservationFill,
  DigitalSignageFill,
  VisitorManagementFill,
  ContactCenterFill,
  VirtualAgentFill,
  EventsFill,
  Webinars,
  RevenueAcceleratorFill,
  WorkvivoFilledV2,
  WEMWorkforceManagement,
  AISlidesFillColor,
  AISheetsFillColor,
  MyNotes,
  AICompanionOnLightFillColor,
  SDKsFill,
  APIsFill,
  Mesh,
  AppsFill,
  ClassicDocFillColor,
  MicrosoftMultiColor,
  GoogleColor,
  MarketplaceFill
} from '@zoom/icons-vue'

import bonsai from './icon-components/bonsai.vue'
import brighthire from './icon-components/brighthire.vue'
import serviceNow from './icon-components/service-now.vue'
import atlassian from './icon-components/atlassian.vue'
import salesforce from './icon-components/salesforce.vue'
import oracle from './icon-components/oracle.vue'
import mcp from './icon-components/mcp.vue'
import realtimeStream from './icon-components/realtime-stream.vue'
import apis from './icon-components/apis.vue'
import coBrowse from './icon-components/co-browse.vue'
export const productIconsMap = {
  meetings: VideoOnFill,
  chat: TeamChatFill,
  phone: PhoneFill,
  'mail-calendar': MailAndCalendarFillProduct,
  scheduler: SchedulerFill,
  canvas: AIDocsFill,
  whiteboard: WhiteboardFill,
  clips: ClipsFill,
  tasks: TasksFill,
  'workflow-automation': FlowFill,
  hub: HubFill,
  'video-management': VideoManagementFill,
  rooms: RoomsFill,
  'workspace-reservation': WorkspaceReservationFill,
  'digital-signage': DigitalSignageFill,
  'visitor-management': VisitorManagementFill,
  'contact-center': ContactCenterFill,
  'virtual-agent': VirtualAgentFill,
  events: EventsFill,
  webinars: Webinars,
  'zoom-events-webinars': Webinars,
  'revenue-accelerator': RevenueAcceleratorFill,
  workvivo: WorkvivoFilledV2,
  'workforce-engagement': WEMWorkforceManagement,
  'cx-insights': Mesh,
  bonsai: bonsai,
  brighthire: brighthire,
  slides: AISlidesFillColor,
  sheets: AISheetsFillColor,
  'my-notes': MyNotes,
  'ai-services': APIsFill,
  'ai-companion': AICompanionOnLightFillColor,
  'custom-ai-companion': AICompanionOnLightFillColor,
  'video-sdk': SDKsFill,
  'cobrowse-sdk': coBrowse,
  overview: AppsFill,
  paper: ClassicDocFillColor,
  microsoft: MicrosoftMultiColor,
  serviceNow: serviceNow,
  google: GoogleColor,
  oracle: oracle,
  salesforce: salesforce,
  atlassian: atlassian,
  'zoom-marketplace': MarketplaceFill,
  mcp: mcp,
  'realtime-media-streams': realtimeStream,
  apis: apis,
  'zoom-apps-sdk': AppsFill,
  'meeting-sdk': VideoOnFill
}
